"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animateIn = void 0;
const animateIn = () => {
    const items = document.querySelectorAll('[data-animate]');
    let observerOptions = {
        rootMargin: '0px 0px -20% 0px',
        threshold: 0
    };
    let observer = new IntersectionObserver(observerCallback, observerOptions);
    function observerCallback(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-in');
            }
        });
    }
    items.forEach((i) => {
        if (i) {
            observer.observe(i);
        }
    });
};
exports.animateIn = animateIn;
